import { getDailyRentalKsaStaticDynamicFieldsResponse } from './dailyRental';
import { getLongTermKsaBaseDynamicFieldsResponse } from './shared/longTermBase';
import { applyBayutKsaProjectListingOverrides } from './shared/projectListingOverrides';
import { getRentKsaBaseDynamicFieldsResponse } from './shared/rentTermBase';

const STATIC_BY_LISTING_PURPOSE_KEY = {
  sale: getLongTermKsaBaseDynamicFieldsResponse,
  rent: getRentKsaBaseDynamicFieldsResponse,
};

export function getBayutKsaStaticDynamicFieldsResponse(arg) {
  if (arg?.isDailyRental) {
    return getDailyRentalKsaStaticDynamicFieldsResponse();
  }
  const key = arg?.listingPurposeKey;
  const getStatic = key && STATIC_BY_LISTING_PURPOSE_KEY[key];
  // Never fall back to /api/surge/dynamic_fields for bayut flows.
  // If purpose key is not resolved yet, use sale base fields as safe default.
  const base = getStatic ? getStatic() : getLongTermKsaBaseDynamicFieldsResponse();
  if (arg?.hasProjectAttached) {
    return applyBayutKsaProjectListingOverrides(base);
  }
  return base;
}
